// extracted by mini-css-extract-plugin
export var actionButton = "_86-1";
export var actionButtons = "_86-2";
export var actions = "_86-0";
export var aiUnread = "_86-10";
export var alignCenter = "_86-h";
export var backWrapper = "_86-3";
export var cellContainer = "_86-4";
export var checkboxContainer = "_86-5";
export var contentContainer = "_86-6";
export var contentHeader = "_86-8";
export var conversationsTableWrapper = "_86-s";
export var draftReplyBadgeContainer = "_86-m";
export var dropdownItem = "_86-b";
export var dropdownItemsContainer = "_86-a";
export var dropdownTitle = "_86-c";
export var errorIcon = "_86-7";
export var filter = "_86-d";
export var gray = "_86-i";
export var headerActionButtons = "_86-e";
export var headerCheckboxContainer = "_86-f";
export var icon = "_86-j";
export var menuContainer = "_86-k";
export var noMoreTicketsIcon = "_86-12";
export var noMoreTicketsSubText = "_86-13";
export var oneLine = "_86-l";
export var optionsButton = "_86-n";
export var plus = "_86-o";
export var portalButtonsWrapper = "_86-g";
export var red = "_86-p";
export var scrolledTop = "_86-9";
export var search = "_86-q";
export var selectedConversationsCount = "_86-r";
export var spinner = "_86-t";
export var strong = "_86-u";
export var summaryCell = "_86-v";
export var tableContainer = "_86-11";
export var tagContainer = "_86-w";
export var threeDots = "_86-x";
export var twoLines = "_86-y";
export var unread = "_86-z";